<script lang="ts">
  import { round, generateMagicIntervals as _generateMagicIntervals, getEnduranceDurationDifficulty } from '@/Util/utils';
  import { _ } from 'svelte-i18n';
  import { format_duration } from '@/time';
  import Label from '@/lib/components/ui/label/label.svelte';
  import * as RadioGroup from '$lib/components/ui/radio-group/index.js';
  import DifficultyDiamonds from '@/DifficultyDiamonds.svelte';
  import type { MagicBucketsFieldsAndData } from '../MagicBuckets/MagicBucketsFieldsAndData';
  import { Separator } from '@/lib/components/ui/separator';
  import { Skeleton } from '@/lib/components/ui/skeleton';

  export let fields: MagicBucketsFieldsAndData;
  export let targetsSource: string;

  function xssSourceToTagName(source: string) {
    return (
      {
        XFAI: 'Forecast Activity Targets',
        XATA: 'Adaptive Training Advisor Targets',
        FF_current: 'Targets with Freshness Feedback',
        FF_historical: 'Adaptive Training Advisor Targets',
        Override: 'User Selected Targets',
      }[source] || "Today's " + source + ' Targets'
    );
  }

</script>

{#if fields.targets}
  <div class='max-w-max flex flex-col gap-1'>
    <div class="text-muted-foreground">
      Magic Buckets brings a new dimension to training and workouts that has never existed previously – interval targets and durations are calculated on-the-fly at each moment.
      <a href="https://www.baronbiosys.com/magic-buckets/" target="_blank">Learn more about Magic Buckets</a>, and how to set it up for your training.
    </div>

    <Separator orientation="horizontal" class="my-2" />

    <!-- {#if targetsSource}
      <h3 class="text-base font-medium m-0 mb-1 text-muted-foreground">{xssSourceToTagName(targetsSource)}</h3>
    {/if} -->

    <div class="flex gap-x-8 gap-y-1 items-center mb-4">
      {#if fields.magicIntervalData}
        {#await fields.magicIntervalChartData}
          <Skeleton class="h-5 w-[120px]" />
          <Skeleton class="h-5 w-[120px]" />
        {:then mpaData}
          {@const summary = mpaData.summary}
          <div>Estimated Duration: <span class="font-medium">{format_duration(summary.duration)}</span></div>
          <div>Difficulty: <span class="font-medium"><DifficultyDiamonds compact difficulty={summary.xds} /> - {round(summary.xds)}</span></div>
        {/await}
      {:else}
        {@const summary = getEnduranceDurationDifficulty(fields.targets.xlss)}
        <div>Estimated Duration: <span class="font-medium">{format_duration(summary.duration)}</span></div>
        <div>Difficulty: <span class="font-medium"><DifficultyDiamonds compact difficulty={summary.difficulty} /> - {round(summary.difficulty)}</span></div>
      {/if}
      <div>
        <span>Target XSS: </span>
        <span class="font-medium">
          {round(fields.targets.xss)}
          <span class="whitespace-nowrap">
            {'('}
            <span class="text-xertlow">{round(fields.targets.xlss)}</span>
            {' | '}
            <span class="text-xerthigh">{round(fields.targets.xhss, 1)}</span>
            {' | '}
            <span class="text-xertpeak">{round(fields.targets.xpss, 1)}</span>
            {')'}
          </span>
        </span>
      </div>
    </div>

    {#if fields.magicIntervalData}
      <div class="space-y-3">
        <div class="font-medium">Challenge Level</div>
        <RadioGroup.Root
          class="flex gap-4 flex-wrap"
          value={fields.selectedChallengeLevel?.toString()}
          onValueChange={(v) => {
            // setIntervalDuration(Math.round(baseIntervalDuration * 1.5))
            fields.selectMagicInterval(Number(v));
          }}
        >
          {#each fields.magicIntervalData ?? [] as mpaData}
            <Label class="flex items-center justify-center text-center rounded-xl w-10 h-10 border-solid border-2 border-muted mb-0 hover:text-accent-foreground hover:bg-accent [&:has(button[data-state='checked'])]:border-primary">
              <div class="">{mpaData.summary.cl}</div>
              <RadioGroup.Item class="sr-only" value={mpaData.summary.cl.toString()} />
            </Label>
          {/each}
        </RadioGroup.Root>
      </div>
    {/if}
  </div>
{/if}
